<template>
  <fragment>
    <div class="margin-bottom-4">
      <div class="sac__font-18 n110 semi-bold">
        Member and Plan Details
      </div>
      <div class="">
        {{ `${firstName} ${lastName} - ${companyName} - ${maintenancePlan}` }}
      </div>
      <div class="">
        {{ email }}
      </div>
      <div class="">
        {{ phoneNumber }}
      </div>
    </div>
    <div class="margin-bottom-4">
      <div class="sac__font-18 n110 semi-bold">
        Service Address
      </div>
      <div class="">
        {{ serviceAddress.address1 }}
      </div>
      <div
        v-if="serviceAddress.address2"
        class=""
      >
        {{ serviceAddress.address2 }}
      </div>
      <div class="">
        {{ serviceAddress.city }}, {{ serviceAddress.state }} {{ serviceAddress.zip }}
      </div>
      <div class="">
        {{ serviceAddress.country }}
      </div>
    </div>
    <div class="">
      <div class="sac__font-18 n110 semi-bold">
        Billing Address
      </div>
      <div v-if="sameAsBilling">
        Same as service address
      </div>
      <fragment v-else>
        <div class="">
          {{ billingAddress.address1 }}
        </div>
        <div
          v-if="billingAddress.address2"
          class=""
        >
          {{ billingAddress.address2 }}
        </div>
        <div class="">
          {{ billingAddress.city }}, {{ billingAddress.state }} {{ billingAddress.zip }}
        </div>
        <div class="">
          {{ billingAddress.country }}
        </div>
      </fragment>
    </div>
  </fragment>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'ConfirmInfo',
  props: {
    firstName: String,
    lastName: String,
    email: String,
    phoneNumber: String,
    corpId: Number,
    billingAddress: Object,
    serviceAddress: Object,
    sameAsBilling: Boolean,
    providerPlanId: Number,
    providerPlans: Array,
  },
  computed: {
    ...mapState({
      currentAdmin: (state) => state.admin.current,
      allPartners: (state) => state.partner?.partners,
    }),
    ...mapGetters([
      'isSmacAdmin',
      'allBranches',
    ]),
    maintenancePlan() {
      const plan = this.providerPlans.find((p) => p.value === this.providerPlanId);
      return plan.label;
    },
    companyName() {
      if (this.allPartners?.length > 0) {
        const partner = this.allPartners.find((p) => p.id === this.corpId);
        return partner.displayName;
      }
      if (this.allBranches(false).length > 0) {
        const partner = this.allBranches(false).find((p) => p.value === this.corpId);
        return partner.label;
      }
      return this.currentAdmin.companyName;
    },
  },
};
</script>
